import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './yupTranslations';
import App from './App';
import '@norges-domstoler/dds-components/index.css';
import './app.css';
import 'src/assets/styles/fonts.scss';

const root = createRoot(document.getElementById('root') ?? document.body);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
